// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Refresh: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M44 8h6c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4h-9.2c-.8 0-1.4.6-1.4 1.4v9.2c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4V10c4.2 4.2 6.5 9.9 6.5 15.8 0 6-2.3 11.7-6.6 15.9C35.8 48 26.3 50 18 46.8c-.7-.3-1.5.1-1.8.8-.3.7.1 1.5.8 1.8 3 1.2 6.1 1.7 9.2 1.7 6.6 0 13.1-2.6 17.9-7.4 4.8-4.8 7.4-11.1 7.4-17.9-.1-6.7-2.8-13-7.5-17.8zM11.5 34.5c-.8 0-1.4.6-1.4 1.4v6l-.1-.1c-4.3-4.3-6.6-9.9-6.6-15.9S5.8 14.2 10 10c6.2-6.2 15.5-8.2 23.8-5.2.7.2 1.5-.1 1.8-.8.3-.7-.1-1.5-.8-1.8C25.5-1.2 15 1.1 8.1 8 3.3 12.8.7 19.1.7 25.9c0 6.7 2.6 13.1 7.4 17.9H2.2c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h9.2c.2 0 .4-.1.6-.2.1-.1.2-.1.3-.2.3-.3.4-.6.4-1V36c.1-.9-.5-1.5-1.2-1.5z"/></svg>;
};

export default React.memo(Refresh);
